import { createSlice } from "@reduxjs/toolkit";

const initialWorkersState = {
  listLoading: false,
  listLoader: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  buyerSellerForEdit: {
    id: undefined,
    name: "",
  },
  message: null,
  messageType: null,
  showMessage: false,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const buyerSellerSlice = createSlice({
  name: "buyerSeller",
  initialState: initialWorkersState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // buyerSeller loader
    buyerSellerListLoading: (state, action) => {
      state.listLoading = action.payload;
    },
    buyerSellerList: (state, action) => {
      const { result, count } = action.payload;

      state.totalCount = count;
      state.entities = result;
      state.listLoader = false;
    },
    listLoad: (state, action) => {
      state.listLoader = action.payload;
    },
    loadBuyerSellerForEdit: (state, action) => {
      state.buyerSellerForEdit = action.payload;
    },
    loadBuyerSellerMessage: (state, action) => {
      const { message, type } = action.payload;

      state.message = message;
      state.messageType = type;
      state.showMessage = true;
    },
  },
});
